import React from 'react'

let HealthCareDirective;

export default class DeferredHealthCareDirective extends React.Component{
  state = {fetchingBundle: true}
  componentDidMount = () => {
    this.fetchDesignerBundle()
  }
  fetchDesignerBundle = () => {
    require.ensure(
  		['./HealthCareDirective'],
  		require => {
  			HealthCareDirective = require('./HealthCareDirective').default
        this.setState({fetchingBundle: false})
  		},
  		'health_care_directive'
  	)
  }
  render(){
    return(
      this.state.fetchingBundle ?
      null
      :
      <HealthCareDirective {...this.props} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/HealthCareDirective/DeferredHealthCareDirective.js